import { useAppDispatch, useAppSelector } from "@/store/hooks"
import { setState } from "@/store/globalSlice"
import ModalButton from "@/Components/ModalButton"
import classNames from "classnames"
import Modal from "@/Components/Modal"

const HouseBuildModal: React.FC = () => {
  const dispatch = useAppDispatch()
  const houseBuildMode = useAppSelector((state) => state.global.houseBuildMode)

  if (!houseBuildMode) return null

  const isBuy = houseBuildMode === "buy"

  const handleCancel = () => {
    dispatch(setState({ houseBuildMode: null }))
  }

  return (
    <Modal
      data-testid="game.house-build-overlay"
      className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[100] w-[90%] max-w-xl"
      icon={
        <i
          className={classNames(
            "fa-solid text-white text-2xl",
            isBuy ? "fa-house" : "fa-coins"
          )}
        ></i>
      }
      title={isBuy ? "Build Houses" : "Sell Houses"}
      subtitle={
        isBuy
          ? "Tap a highlighted property to build a house and raise its rent."
          : "Tap a highlighted property to sell a house and get money back."
      }
      contentClassName="flex flex-col items-center gap-7 px-12 pb-11"
    >
      {/* Divider */}
      <div className="h-px w-2/3 bg-gradient-to-r from-transparent via-amber-400/50 to-transparent" />

      <ModalButton
        color={isBuy ? "green" : "yellow"}
        onClick={handleCancel}
        data-testid="game.house-build-cancel-btn"
      >
        <div className="flex flex-row items-center justify-center gap-3 w-full">
          <i className="fa-check fa-solid text-white fa-lg"></i>
          <span className="text-lg text-white font-poppins font-semibold tracking-wide uppercase">
            Done
          </span>
        </div>
      </ModalButton>
    </Modal>
  )
}

export default HouseBuildModal
